import { render } from "./SoftField.vue?vue&type=template&id=2efa19c6&scoped=true"
import script from "./SoftField.vue?vue&type=script&lang=js"
export * from "./SoftField.vue?vue&type=script&lang=js"

import "./SoftField.vue?vue&type=style&index=0&id=2efa19c6&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efa19c6"]])

export default __exports__